import { Skeleton } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MultiAxisLineChart from "shared/components/lineGraph";
import RangeDatePicker from "shared/components/rangeDatePicker";
import { getUserGraphDetail } from "shared/services/projectHeadService";
import { user_roles } from "shared/utils/constants";
import styles from "./style.module.scss";

function TransactionGraph({ allTimeRecord, selectedAgeRange }: any) {
  const params = useParams();
  const keyword: any = params?.keyword;
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [graphData, setGraphData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  //eslint-disable-next-line
  const [activeRole, setActiveRole] = useState<number | null>(
    keyword === "individuals"
      ? user_roles.reader
      : keyword === "parents"
      ? user_roles.parent
      : keyword === "schools"
      ? user_roles.school
      : null
  );

  let dataSetsForGraphs = [
    {
      label: "Total Accounts",
      data: graphData?.total,
      borderColor: "#9A469B",
      backgroundColor: "#9A469B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#9A469B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Premium Accounts",
      data: graphData?.membership,
      borderColor: "#EF437B",
      backgroundColor: "#EF437B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Free Accounts",
      data: graphData?.free,
      borderColor: "#1897A6",
      backgroundColor: "#1897A6",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Expired Account",
      data: graphData?.expired,
      borderColor: "#ADB5BD",
      backgroundColor: "#ADB5BD",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#ADB5BD",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Repurchased Accounts",
      data: graphData?.repurchase,
      borderColor: "#FDA504",
      backgroundColor: "#FDA504",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#FDA504",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  const getStats = () => {
    setLoader(true);
    getUserGraphDetail(
      selectedAgeRange,
      Number(activeRole),
      allTimeRecord
        ? null
        : {
            from: moment(startDate).format("YYYY-MM-DD"),
            to: moment(endDate).format("YYYY-MM-DD"),
          }
    )
      .then(({ data }) => {
        // console.log("Data", data?.data);
        setGraphData(data?.data);
        setLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStats();
    }

    //eslint-disable-next-line
  }, [startDate, endDate, allTimeRecord, selectedAgeRange]);

  return (
    <div className={styles.graphMainContainer}>
      <div className={styles.headingContainer}>
        <div className={styles.analyticsHeading}>Accounts Detail</div>

        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>
      <div className={styles.graphContainer}>
        {loader ? (
          <Skeleton variant="rounded" width={"100%"} height={500} />
        ) : (
          <MultiAxisLineChart
            datasets={dataSetsForGraphs}
            legend={false}
            canvasStyle={styles.canvas}
            responsive={true}
            labels={graphData?.labels}
          />
        )}
      </div>
    </div>
  );
}

export default TransactionGraph;
